import { ReactComponent as LogoSVG } from '@/asset/svg/logo.svg'
import LinkEnhance from '@/component/LinkEnhance'
import useMultiClick from '@/hook/useMultiClick'
import useWebTitle from '@/hook/useWebTitle'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Logo: React.FC<PropType> = () => {
  const title = useWebTitle()
  const navigate = useNavigate()

  const handleClick = useMultiClick(10, 1000, () => {
    navigate('/debug/')
  })

  return (
    <h1 className="!text-lg font-semibold" onClick={handleClick}>
      {true ? (
        <LinkEnhance>{title}</LinkEnhance>
      ) : (
        <LinkEnhance>
          <LogoSVG className="w-40 fill-current" />
        </LinkEnhance>
      )}
    </h1>
  )
}

interface PropType {}

export default Logo
